
import { defineComponent } from '@nuxtjs/composition-api';
import {
  getProductImage,
  getProductTags,
  getProductDescription,
  getProductLink,
} from '~/helpers/productContent';
import CatalogProductCard from '~/domains/catalog/components/CatalogProductCard.vue';

export default defineComponent({
  name: 'RelatedProducts',
  components: { CatalogProductCard },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const swiperOptions = {
      observer: true,
      slidesPerView: 'auto',
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 180,
        snapOnRelease: true,
      },
      lazy: {
        enabled: true,
        checkInView: true,
        loadPrevNext: true,
        loadPrevNextAmount: 5,
      },
    };

    return {
      swiperOptions,
      getProductImage,
      getProductDescription,
      getProductTags,
      getProductLink,
    };
  },
});
